import { CssBaseline } from "@mui/material";
import * as ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import { broadcastQueryClient } from "@tanstack/query-broadcast-client-experimental";
import { createAsyncStoragePersister } from "@tanstack/query-async-storage-persister";
import { QueryClient } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { PersistQueryClientProvider } from "@tanstack/react-query-persist-client";
import { SnackbarProvider } from "notistack";
import App from "./app/App";
import { initFirebase } from "./app/misc/firebase";
import { initSentry } from "./app/misc/sentry";
import { registerStaleChunkReload } from "./app/misc/staleChunkReload";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      gcTime: 1000 * 60 * 60 * 4, // 4 hours
      staleTime: 1000 * 60 * 15, // 15 minutes
    },
  },
});

const persister = createAsyncStoragePersister({
  storage: window.localStorage,
});

broadcastQueryClient({ queryClient });

const render = (root: ReactDOM.Root) => {
  root.render(
    <BrowserRouter>
      <CssBaseline />
      <PersistQueryClientProvider client={queryClient} persistOptions={{ persister, maxAge: 1000 * 60 * 60 * 4 }}>
        <SnackbarProvider maxSnack={3}>
          <App />
        </SnackbarProvider>
        <ReactQueryDevtools initialIsOpen={false} />
      </PersistQueryClientProvider>
    </BrowserRouter>,
  );
};

export default (rootElement: HTMLElement) => {
  const root = ReactDOM.createRoot(rootElement);
  initFirebase();
  initSentry();
  registerStaleChunkReload();
  render(root);
};
